import React from 'react'

import { useStoryReader } from '@hooks/book/useStoryReader'
import { useAuthentication } from '@hooks/useAuthentication'
import {
  WriterInformationProps,
  WriterInformationAcceptProps,
} from './interface'

export function withWriterInformation(
  Component: React.FC<WriterInformationProps>
) {
  function Hoc({ className }: WriterInformationAcceptProps) {
    const { user } = useAuthentication()
    const {
      data,
      isToggleFollowUserLoading,
      isToggleFollowPenNameLoading,
      isFollowedPenName,
      isFollowedUser,
      handleFollowUser,
      handleFollowPenName,
    } = useStoryReader()

    if (!data) return null

    const newProps = {
      className,
      penName: data.penName,
      publishedAt: data.publishedAt,
      updatedAt: data.updatedAt,
      isFollowedUser,
      isFollowedPenName,
      isToggleFollowUserLoading,
      isToggleFollowPenNameLoading,
      canFollow: data.penName.user.id !== user.id,
      handleFollowUser,
      handleFollowPenName,
    }
    return <Component {...newProps} />
  }

  return Hoc
}

export default withWriterInformation
